import cn from 'classnames';
import type { PropsWithChildren, ReactNode } from 'react';
import { Card, type CardProperties, resolveClassNames } from 'ui';

type P = PropsWithChildren<{
  cardProperties?: CardProperties;
  header?: ReactNode;
}>;

const defaultRootClassName = 'fit-content-page-layout__main';
const defaultBodyClassName = 'fit-content-page-layout__body';

const FitContentPageLayout = ({ cardProperties, children, header }: P) => {
  const { classNames, ...restMainContentProperties } = cardProperties ?? {};
  const mergedClassNames = resolveClassNames(classNames, (resolvedClassNames) => ({
    ...resolvedClassNames,
    body: cn(defaultBodyClassName, resolvedClassNames?.body),
    root: cn(defaultRootClassName, resolvedClassNames?.root),
  }));

  return (
    <div className="fit-content-page-layout">
      {header}
      <Card classNames={mergedClassNames} marginBottom={false} {...restMainContentProperties}>
        {children}
      </Card>
    </div>
  );
};

export default FitContentPageLayout;
